var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NbSelectInput',{attrs:{"options":_vm.iconTerms,"id":"select-action","error":_vm.errors},model:{value:(_vm.actionValue),callback:function ($$v) {_vm.actionValue=$$v},expression:"actionValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }